var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateClient',{attrs:{"subtitle":_vm.$t('client.shipping_return.title')}},[_c('p',[_vm._v("Contenu en cours de développement")])])
}
var staticRenderFns = []

export { render, staticRenderFns }